import { useIntl } from 'react-intl'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import '../../style/stakeholders.scss'
import { PageTitle } from '../../../../../_metronic/layout/core'
import { StakeholdersBreadcrum } from '../core/_constants'
import RectangularTabs from '../../../widgets/components/RectangularTabs'
import { useModuleStatus } from '../../../../hooks/useModuleStatus'
import Shareholder from '../components/shareholder/shareholder'
import SecurityClass from '../components/security-class/security-class'
// import { useAuth } from '../../../auth'

export const ShareholdersAndInvestors = () => {

  const location = useLocation()
  const navigate = useNavigate() // Get the navigate function
  const { formatMessage } = useIntl()
  // const { planStatus } = useAuth()
  const { StakeholdersBreadCrum } = StakeholdersBreadcrum()
  const { moduleStatus } = useModuleStatus()

  const options = [
    {
      id: 1,
      title: formatMessage({ id: 'Shareholders & Investors' }),
      subTitle: formatMessage({ id: 'Manage all the shareholders and investors' }),
      slug: 'shareholders-and-Investors',
    },
    {
      id: 2,
      title: formatMessage({ id: 'Security Classes' }),
      subTitle: formatMessage({ id: 'Share & Other Security Classes' }),
      slug: 'security-Classes',
    },
  ]

  // Filter options based on moduleStatus
  const filteredOptions = moduleStatus['stakeholder'] !== false
    ? options
    : options.filter((option) => ![2].includes(option.id));

  // State for managing the selected tab
  const [selectedTab, setSelectedTab] = useState<number>(filteredOptions[0]?.id || 1);

  // Handle tab change
  const handleTabChange = (id: number) => {
    setSelectedTab(id);
    const selectedOption = options.find(option => option.id === id);
    if (selectedOption) {
      navigate(`${location.pathname}?tab=${selectedOption.slug.toLowerCase()}`);
    }
  };

  useEffect(() => {
    const handleTabChange = () => {
      navigate(`${location.pathname}?tab=${options[0].slug}`)
    }
    handleTabChange() // eslint-disable-next-line
  }, [])

  return (
    <>
      <PageTitle
        breadcrumbs={StakeholdersBreadCrum}
        description={formatMessage({ id: 'Shareholders and Investors' })}
      >
        {formatMessage({ id: 'Shareholders and Investors' })}
      </PageTitle>
      {/* button for Desktop view */}
      <div
        // className={`d-flex align-items-center justify-content-end position-absolute gap-2 gap-lg-3 d-none d-sm-block ${planStatus === 'payment_due' && 'planstatus-adjustment'}  ${planStatus === 'paid' && 'planstatus-not-adjustment'}`}
        className='d-flex align-items-center justify-content-end position-absolute gap-2 gap-lg-3 d-none d-sm-block'
        style={{ top: '80px', right: '30px' }}
      >
        <div className='d-flex flex-column mt-3 top-btn-main'>
          <div className='d-flex justify-content-end'>
            <button
              className={`btn bg-primary custom-button-property font-size-13 text-white font-weight-400 w-100 ${selectedTab !== 1 && 'd-none'
                }`}
              onClick={() => navigate('../add-stakeholder?tab=individual')}
            >
              {formatMessage({ id: 'Add Shareholder' })}
            </button>
          </div>
        </div>
      </div>
      {/* button for mobile view */}
      <div className='d-flex align-items-center gap-2 gap-lg-3 d-block d-sm-none'>
        <div className='d-flex flex-column mt-3 top-btn-main'>
          <div className='d-flex justify-content-end'>
            <button
              className={`btn bg-primary custom-button-property font-size-13 text-white mb-4 font-weight-400 w-100 ${selectedTab !== 1 && 'd-none'
                }`}
              onClick={() => navigate('../add-stakeholder')}
            >
              {formatMessage({ id: 'Add Shareholder' })}
            </button>
          </div>
        </div>
      </div>

      <RectangularTabs
        options={filteredOptions}
        selectedTab={selectedTab}
        handleTabChange={handleTabChange}
      />


      <div className='col-12 mt-5 mb-9 w-100'>

        {selectedTab === 1 && (

          <Shareholder />
        )}

        {selectedTab === 2 && (
          <SecurityClass />
        )}
      </div>


    </>
  )
}

